export { default } from "./AIScoutingSummaryCardContainer";
